import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';

export const styles = stylex.create({
  dropdownContainer: {
    position: 'relative',
    display: 'inline-block',
    boxSizing: 'border-box',
    fontFamily: fonts.din2014Regular,
  },
  dropdownButton: {
    cursor: 'pointer',
    backgroundColor: colors.primaryBackground,
    border: `1px solid ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusS,
    color: colors.primaryText,
  },
  dropdownButtonDisabled: {
    padding: '8px 12px',
    opacity: 0.6,
    cursor: 'not-allowed',
    backgroundColor: colors.ghostText,
  },
  dropdownItemDisabled: {
    opacity: 0.2,
    cursor: 'default',
    color: colors.ghostText,
    ':hover': {
      backgroundColor: 'inherit',
    },
  },

  dropdownList: {
    position: 'absolute',
    left: 0,
    right: 0,
    border: `1px solid ${colors.ghostBorder}`,
    margin: 0,
    padding: 4,
    listStyle: 'none',
    zIndex: 999,
    marginTop: '4px',
    borderRadius: anatomy.borderRadiusS,
    backgroundColor: colors.primaryBackground,
  },
  dropdownItem: {
    padding: '8px 12px',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    fontSize: typography['fontSizeCaption-1'],
    color: colors.primaryText,
    ':hover': {
      backgroundColor: colors.hoverBackground,
      borderRadius: anatomy.borderRadiusXs,
    },
  },
  dropdownItemSelected: {
    backgroundColor: colors.hoverBackground,
    borderRadius: anatomy.borderRadiusXs,
  },
  dropdownItemButton: {
    width: '100%',
    textAlign: 'left',
    cursor: 'inherit',
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
    color: colors.primaryText,
  },
});
